<template>
    <div
        class="level-card"
        :style="{ 
            color: data.fontColor || '#fff', 
            'background-color': data.levelBackgroundColor,
        }"
    >
    <!-- 
            'background-image': `url(https://cdn01.xiaogj.com/uploads/x3/assets/m/img/parent/member/l${data.level}.png)`   -->
        <div v-if="data.level !== 0">
            <div class="a">
                <span class="a1">{{ data.name }}</span>
            </div>
            <div class="c" v-if="!data.isCurrent && data.nextPoint > 0">再积 {{ data.nextPoint }} 积分可升到此等级</div>
            <div class="c" v-if="data.isCurrent && data.nextLevel">再积 {{ data.nextLevelPoint }} 积分可升到{{ data.nextLevel.levelName }}</div>
            <div class="no" v-if="data.no && data.isCurrent">NO.{{ data.no }}</div>
        </div>
        <div class="tag" :class="{ bgc: !data.isCurrent }" v-if="data.level > 0 && data.no">{{ data.isCurrent ? '当前等级' : '待升级' }}</div>
    </div>
</template>

<script >
export default {
    props: {
        data: {
            type: Object,
            default: () => ({})
        }
    }
}
</script>

<style lang="scss" scoped>
.level-card {
    color: #fff;
    box-sizing: border-box;
    height: 150px;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    border-radius: 10px;
    box-shadow: 0px 5px 12px 0px rgba(230, 190, 130, 0.24);
    padding: 0 16px;
    position: relative;
    .a {
        padding-top: 22px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .a1 {
            font-size: 18px;
            font-weight: 600;
        }
    }

    .no {
        font-size: 14px;
        position: absolute;
        left: 16px;
        bottom: 16px;
    }
    // .b {
    //     margin-top: 40px;
    // }
    .c {
        font-size: 12px;
        margin-top: 8px;
        font-weight: 500;
    }
    .tag {
        color: #fafbfa;
        background-color: #575757;
        border-radius: 10px 0px 10px 0px;
        position: absolute;
        left: 0;
        top: 0;
        font-size: 10px;
        padding: 1px 5px;
    }
    .tag.bgc {
        background-color: #bbb;
    }
}
</style>
